/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldExistsFilterDefinition } from './fieldExistsFilterDefinition';


export interface DeviceExternalRequestDto { 
    page?: number;
    count?: number;
    orderBy?: string;
    orderDirection?: string;
    deviceIdsFilter?: Array<number>;
    testDeviceFilter?: boolean;
    customerRefNoFilter?: Array<string>;
    batteryTypeIdFilter?: Array<string>;
    deviceTypeIdFilter?: Array<string>;
    firmwareVersionIdFilter?: Array<string>;
    parametersSet?: Array<string>;
    pcbTypeIdFilter?: Array<string>;
    customerContactFilter?: Array<string>;
    gpsPlusDeviceFilter?: boolean;
    replacedByIdFilter?: Array<number>;
    orderItemConfigurationIdFilter?: Array<string>;
    shippingDateBeforeFilter?: string;
    shippingDateAfterFilter?: string;
    genericFieldExistsFilter?: Array<Array<FieldExistsFilterDefinition>>;
    userSubsystemIdentifierVisibilityEnabled?: Array<number>;
    rmaIdFilter?: Array<string>;
    nameFilter?: string;
    userFilter?: Array<string>;
    keywords?: Array<string>;
    deviceManufacturingStatusFilter?: Array<DeviceExternalRequestDto.DeviceManufacturingStatusFilterEnum>;
}
export namespace DeviceExternalRequestDto {
    export const DeviceManufacturingStatusFilterEnum = {
        New: 'New',
        Assigned: 'Assigned',
        ReadyForTest: 'ReadyForTest',
        Testing: 'Testing',
        ManufacturingCompleted: 'ManufacturingCompleted',
        Packed: 'Packed',
        Shipped: 'Shipped',
        Canceled: 'Canceled',
        ManufacturingFailed: 'ManufacturingFailed'
    } as const;
    export type DeviceManufacturingStatusFilterEnum = typeof DeviceManufacturingStatusFilterEnum[keyof typeof DeviceManufacturingStatusFilterEnum];
}


